import logoUrl from '../assets/maytomation-logo.svg';
import iconUrl from '../assets/maytomation-icon.svg';
import { cn } from '../lib/cn';

type LogoProps = {
  compact?: boolean;
  className?: string;
};

export function Logo({ compact = false, className }: LogoProps) {
  return (
    <img
      src={compact ? iconUrl : logoUrl}
      alt="MaytoMation"
      className={cn(compact ? 'h-11 w-11' : 'h-10 w-auto', className)}
    />
  );
}
